<template>
  <div id="app">
    <router-view></router-view>
    <h1 id="mainAlert" class="warningTemporary">
      <span id="mainAlertTxt">warning</span>
      <span class="mainAlertTxtclose" v-on:click="notifyErrorForceClose()">
        X
      </span>
    </h1>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "app",
  created() {
    this.checkUrl();
  },
  data() {
    return {};
  },
  methods: {
    notifyErrorForceClose() {
      mainAlert.classList.remove("mainAlertShow");
    },

    checkUrl() {
      let url = window.location.href;
      if (url.includes("stratumblue") && !url.includes("rc")) {
        window.location.replace("https://bluetoken.io/app/login");
      }
    },
  },
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Merienda&display=swap');
.warningTemporary {
  // box-shadow: 0px -5px 3px rgba(227, 218, 218, 0.67);
  background-color: #3e4969;
  // background-color:rgb(220, 31, 31);
  position: fixed;
  bottom: 10vh;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: white;
  font-size: 1.2em;
  padding: 12px 0;
  margin-bottom: 0;
  display: none;
  animation-name: slowShow;
  animation-duration: 0.5s;
  z-index: 99999;
  padding: 25px 10px;

  .mainAlertTxtclose {
    margin: 0px 10px;
    background-color: white;
    border-radius: 50%;
    padding: 0px 6px;
    color: #1a8f1a;
    cursor: pointer;
  }
}

.alert_danger {
  background-color: rgb(209, 40, 40) !important;
  .mainAlertTxtclose {
    color: rgb(209, 40, 40);
  }
}
.alert_success {
  background-color: rgb(58, 202, 30);
  background-color: rgb(41, 211, 174);
  .mainAlertTxtclose {
    color: rgb(58, 202, 30);
    color: rgb(41, 211, 174);
  }
}
.alert_warning {
  background-color: rgb(211, 188, 60);
  .mainAlertTxtclose {
    color: rgb(211, 188, 60);
  }
}
.alert_info {
  background-color: rgb(109, 109, 212);
  .mainAlertTxtclose {
    color: rgb(109, 109, 212);
  }
}
.mainAlertShow {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue